import {mapActions} from "vuex";

const mapMixin = {
    data() {
        return {
            rates: [],
            currentUserGeolocation: null
        }
    },

    computed: {},

    methods: {
        ...mapActions({
            fetchPinPlaces: 'place/fetchPinPlaces'
        }),

        getMapCordinates(cordinates) {
            return {
                rightTopLat: 0,
                rightTopLng: 0,
                leftBottomLat: 0,
                leftBottomLng: 0
                // rightTopLat: cordinates.getNorthEast().lat(),
                // rightTopLng: cordinates.getNorthEast().lng(),
                // leftBottomLat: cordinates.getSouthWest().lat(),
                // leftBottomLng: cordinates.getSouthWest().lng()
            }
        },
        //returns in meters
        calcDistance(lat1, lon1, lat2, lon2) {
            var R = 6371; // km
            var dLat = this.toRad(lat2 - lat1);
            var dLon = this.toRad(lon2 - lon1);
            var lat1 = this.toRad(lat1);
            var lat2 = this.toRad(lat2);

            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d * 1000;
        },

// Converts numeric degrees to radians
        toRad(Value) {
            return Value * Math.PI / 180;
        },

        async getListWithoutCoords() {
            this.rates = []
            const response = await this.fetchPinPlaces({})
            localStorage.removeItem('temp_token')
            if (response.success) {
                this.rates = response.places;
            } else {
                this.showErrorModal()
            }
        },
        async getList(cordinates) {
            this.rates = []
            const response = await this.fetchPinPlaces(cordinates)
            localStorage.removeItem('temp_token')
            if (response.success) {
                this.rates = response.places;
            } else {
                this.showErrorModal()
            }
        },

        clearUnlinkedQuestion() {
            localStorage.removeItem('unlinked_rate')
            localStorage.removeItem('unlinked_rate_question')
            localStorage.removeItem('unlinked_rate_question_location')
            localStorage.removeItem('unlinked_rate_place_guid')
        },

        geolocate(settings, successCallback) {
            const options = {
                enableHighAccuracy: true
            };

            console.log(this.currentUserGeolocation)
            if (this.currentUserGeolocation) {

                this.center = {
                    lat: this.currentUserGeolocation.lat + Math.random() / 99999,
                    lng: this.currentUserGeolocation.lng + Math.random() / 99999,
                    accuracy: this.currentUserGeolocation.accuracy
                }
                console.log('settings:', settings)

                this.zoom = settings && settings.zoom || 18;
                if (this.$refs.mapModal) {
                    this.$refs.mapModal.zoom = this.zoom
                    console.log("mapModal:", this.$refs.mapModal)
                }
                console.log('zoom:', this.zoom)
                if (successCallback) {
                    successCallback(this.center.lat, this.center.lng, this.zoom, this.center.accuracy)
                }
            } else {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log('settings:', settings)

                    const currentCoordinates = {
                        lat: position.coords.latitude + Math.random() / 99999,
                        lng: position.coords.longitude + Math.random() / 99999,
                        accuracy: position.coords.accuracy
                    }
                    this.currentUserGeolocation = currentCoordinates
                    this.center = currentCoordinates

                    this.zoom = settings && settings.zoom || 18;
                    if (this.$refs.mapModal) {
                        this.$refs.mapModal.zoom = this.zoom
                        console.log("mapModal:", this.$refs.mapModal)
                    }
                    console.log('zoom:', this.zoom)
                    if (successCallback) {
                        successCallback(this.center.lat, this.center.lng, this.zoom, this.center.accuracy)
                    }
                }, () => {
                }, options);
            }
        },

        GMapCircle(lat, lng, rad, detail = 8) {
            var staticMapSrc = '&path=fillcolor:0x0000FF08|color:0x0000FFFF|weight:1';
            var r = 6371;

            var pi = Math.PI;

            var _lat = (lat * pi) / 180;
            var _lng = (lng * pi) / 180;
            var d = (rad / 1000) / r;

            var i = 0;

            for (i = 0; i <= 360; i += detail) {
                var brng = i * pi / 180;

                var pLat = Math.asin(Math.sin(_lat) * Math.cos(d) + Math.cos(_lat) * Math.sin(d) * Math.cos(brng));
                var pLng = ((_lng + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(_lat), Math.cos(d) - Math.sin(_lat) * Math.sin(pLat))) * 180) / pi;
                pLat = (pLat * 180) / pi;

                staticMapSrc += "|" + pLat + "," + pLng;
            }

            return encodeURI(staticMapSrc);
        },

        startWatchingGps(successCallback, errorCallback) {
            let options = {
                enableHighAccuracy: true,
            };
            navigator.geolocation.watchPosition(position => {
                console.log(`watch location-got new data:`, position)
                const currentCoordinates = {
                    lat: position.coords.latitude + Math.random() / 99999,
                    lng: position.coords.longitude + Math.random() / 99999,
                    accuracy: position.coords.accuracy
                }
                this.currentUserGeolocation = currentCoordinates
                if (successCallback) {
                    successCallback(currentCoordinates)
                }
            }, (error) => {
                console.log(`error watch location:`, error)
                if (errorCallback) errorCallback(error)
            }, options);
        },

        checkCoordsEqual(coord1, coord2) {
          return Math.round(coord1 * 1000000) == Math.round(coord2 * 1000000)
        },
    }
};

export default mapMixin;